/* eslint-disable no-extra-boolean-cast */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Input, InputMasks } from '@/components/shadcn/ui/input';
import { BoxIcon, PlusIcon } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import { Button } from '@/components/shadcn/ui/button';
import CustomInputCurrencyMask from '../../../utils/customInputCurrencyMask';

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/shadcn/ui/dialog';
import { Form, FormControl, FormField, FormLabel, FormItem, FormMessage } from '@/components/shadcn/ui/form';
import { Textarea } from '@/components/shadcn/ui/textarea';
import CustomInputPercentageMask from '@/utils/customInputPercentageMask';
import { Switch } from '@/components/shadcn/ui/switch';
import CustomInputPhoneMask from '@/utils/customInputPhoneMask';

type ColaboratorFormProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onColaboratorSubmit: (data: any) => void;
  setSelectedColaborator: (data: any | undefined) => void;
  data2?: any;
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  setEdit: (value: boolean) => void;
  editing: boolean;
};

const schema = z.object({
  nome: z.number(),
  email: z.string(),
  isAdmin: z.boolean().default(false),
  phone: z.string(),
  whatsapp: z.string(),
});

export const ColaboratorForm: React.FC<ColaboratorFormProps> = ({ onColaboratorSubmit, editing, data2, isOpen, setOpen, setEdit, setSelectedColaborator }) => {
  const form = useForm({
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (data2) {
      form.setValue('nome', data2.name || '');
      form.setValue('email', data2.email || '');
      form.setValue('isAdmin', data2.isAdmin || false);
      form.setValue('phone', data2.cellPhone || '')
      form.setValue('whatsapp', '');
    }
  }, [data2, form]);

  const phoneInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    e.target.value = CustomInputPhoneMask.format(value);
  };


  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = form.getValues();
    const cleanedPhone = '+55' + data.phone.replace(/\D/g, '');
    data.whatsapp = cleanedPhone;

    onColaboratorSubmit(data);

    // setOpen(false);
  };
  return (
    <Dialog open={isOpen} onOpenChange={() => {
      setOpen(!isOpen);
      setEdit(false);
      setSelectedColaborator(undefined);
    }}>
      <DialogTrigger>
        <div className=''>
          <Button variant='ghost' className='gap-1 mt-2 bg-indigo-50 hover:bg-indigo-100' >
            <PlusIcon size={12} />
            Adicionar Colaborador
          </Button>
        </div>
      </DialogTrigger>
      <DialogContent className='w-4/5 h-[70%]'>
        <DialogHeader>
          <DialogTitle>
            <div className='flex items-center gap-2'>
              <BoxIcon size={22} />
              Novo Colaborador
            </div>
          </DialogTitle>
        </DialogHeader>

        {/* Começo do Formulário */}
        <Form {...form}>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className='grid gap-4 pt-2'>

              {/* id */}
              <FormField
                control={form.control}
                name="Id"
                render={({ field }) => (
                  <input type="hidden" onChange={(e) => {
                    field.onChange(e);
                  }} defaultValue={data2 !== undefined ? data2.id : undefined} />
                )}
              />

              {/* nome */}
              <FormField
                control={form.control}
                name="nome"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Nome do Colaborador</FormLabel>
                    <FormControl>
                      <Input
                        defaultValue={data2 !== undefined ? data2.name : undefined}
                        placeholder={'Digite o nome do colaborador'}
                        onChange={(e) => {
                          field.onChange(e);
                        }}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {/* descrição */}
              <FormField
                control={form.control}
                name='email'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Email</FormLabel>
                    <FormControl>
                      <Input
                        defaultValue={data2 !== undefined ? data2.email : undefined}
                        placeholder={'Digite o email do colaborador'}
                        onChange={(e) => {
                          field.onChange(e);
                        }}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="phone"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Telefone</FormLabel>
                    <FormControl>
                      <Input placeholder={'Digite o telefone do Vendedor'}
                       defaultValue={data2 !== undefined ? data2.cellPhone : undefined}
                        onChange={(e) => {
                          phoneInputChange(e);
                          field.onChange(e);
                        }} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              {/* isAdmin toggle */}
              <FormField
                control={form.control}
                name="isAdmin"
                render={({ field }) => (
                  <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3 shadow-sm">
                    <div className="space-y-0.5">
                      <FormLabel>É Admin?</FormLabel>
                    </div>
                    <FormControl>
                      <Switch
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />

            </div>
            <DialogFooter>
              <Button type='submit' className='bg-indigo-700' onClick={() => {
                setOpen(!isOpen);
              }}>{editing ? 'Editar Colaborador' : 'Cadastrar Colaborador'}</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>

  );
};
